import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import SiteHeader from './SiteHeader';
import SiteHeaderV2 from '../SiteHeader.new_site_header';
import * as actions from './redux/actions';
import reducer from './redux/reducer';
export { actions, reducer };
export default withFeatureBranch({
    new_site_header: SiteHeaderV2,
})(SiteHeader);
//# sourceMappingURL=index.js.map